"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ddd_json_1 = __importDefault(require("../utils/ddd.json"));
var validateLandline = function (value) {
    var regex = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:([2-9]\d{3})-?(\d{4}))$/;
    var match = value.match(regex);
    if (!match)
        return 'Telefone fixo inválido!';
    var ddd = "".concat(match.at(-3));
    return ddd_json_1.default.includes(ddd) ? false : 'Por favor digite um ddd válido!';
};
exports.default = validateLandline;
//# sourceMappingURL=landline.js.map